import { compose, createStore, applyMiddleware } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import createSagaMiddleware, { END } from 'redux-saga'
import createRootReducer from './reducers'
import { createMigrate, persistReducer } from 'redux-persist'
import localforage from 'localforage'
import { initialState as initialSmbCartState } from './reducers/smbCart'
import { initialState as initialCreateACardState } from './reducers/createACard'

/*
    See https://github.com/rt2zz/redux-persist#migrations and https://github.com/rt2zz/redux-persist/blob/master/docs/migrations.md.
    Here we can keep track of a list of state changes over time by incrementing the version in persistConfig and creating
    a migration key with the same value in the migrations object. For now, this first migration should reset any previous
    DB connections to all updated initial state for both smbCart and createACard reducers. Set debug: true below when testing
    migrations in dev to see whether or not the migration has taken effect.
 */
const migrations = {
    1: (state) => {
        console.log('First migration running...')
        return Promise.resolve({
            smbCart: { ...initialSmbCartState },
            createACard: { ...initialCreateACardState },
        })
    },
}

const persistConfig = {
    key: 'root',
    version: 1,
    storage: localforage,
    whitelist: ['smbCart', 'createACard'],
    migrate: createMigrate(migrations, { debug: false }),
}

const sagaMiddleware = createSagaMiddleware()

const configureStore = (initialState = {}, history) => {
    const composeEnhancers =
        process.env.NODE_ENV !== 'production' &&
        typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
            ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                  shouldHotReload: false,
              })
            : compose

    const middlewares = [sagaMiddleware, routerMiddleware(history)]

    const enhancers = [applyMiddleware(...middlewares)]
    const rootReducer = createRootReducer(history)
    const persistedRootReducer = persistReducer(persistConfig, rootReducer)
    const store = createStore(
        persistedRootReducer,
        composeEnhancers(...enhancers)
    )

    store.runSaga = sagaMiddleware.run
    store.asyncReducers = {}
    store.close = () => store.dispatch(END)

    if (module.hot) {
        // Enable webpack hot module replacement for reducers
        module.hot.accept('./reducers', () => {
            import('./reducers').then((reducerModule) => {
                const createReducers = reducerModule.default
                const nextReducers = createReducers(store.asyncReducers)
                store.replaceReducer(nextReducers)
            })
        })
    }

    return store
}

export default configureStore
